var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container"},[(_vm.showReady)?_c('h1',[_vm._v(_vm._s(_vm.getMessage('TTL_LISTO')))]):_vm._e(),_c('h1',[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }